import type { TranslationTree } from '../../types';

export const camera: TranslationTree = {
  camera: {
    switchCamera: 'Changer de caméra',
    error: {
      title: 'Erreur de caméra',
      description: "Nous n'avons pas pu accéder à votre caméra.",
      button: 'Réessayer',
      notAllowed: "L'accès à la caméra a été refusé — autorisez l'accès dans les paramètres du navigateur et réessayez.",
      notFound: "Aucune caméra n'a été trouvée sur cet appareil.",
      aborted: "L'accès à la caméra a été interrompu — veuillez réessayer.",
      unknown: 'Une erreur de caméra inattendue s\'est produite ({{name}}).',
      generic: 'La caméra est indisponible — veuillez réessayer.',
    },
  },
};
